// Module
var code = "<multiselect-field :value=\"value\" :with-overflow-count=\"withOverflowCount\" :randomize-color=\"randomizeColor\" :show-remove=\"showRemove\" @overflow-click=\"onOverflowClick\" @remove=\"remove\"></multiselect-field> ";
// Exports
export default code;